import { ModalState } from "../recoil/modal";
import { useCallback } from "react";
import { useSetRecoilState } from "recoil";
import * as modalComponents from "../modals";

export interface ModalProps {
  hash?: string;
  payload?: any;
}

export interface ModalInterface extends ModalProps {
  type: keyof typeof modalComponents;
}

export const useModal = () => {
  const setModalState = useSetRecoilState(ModalState);

  return {
    onModal: useCallback(
      (state: ModalInterface) => {
        setModalState((prev) => [
          ...prev,
          {
            ...state,
            hash:
              Math.random().toString(36).substring(2, 11) +
              new Date().getTime(),
          },
        ]);
      },
      [setModalState]
    ),
    offModal: useCallback(
      (hash: ModalInterface["hash"]) => {
        setModalState((prev) => prev.filter((modal) => modal.hash !== hash));
      },
      [setModalState]
    ),
  };
};
